import { render, staticRenderFns } from "./abnormal-approve-list-page.html?vue&type=template&id=9dfe43fa&"
import script from "./abnormal-approve-list-page.ts?vue&type=script&lang=ts&"
export * from "./abnormal-approve-list-page.ts?vue&type=script&lang=ts&"
import style0 from "./abnormal-approve-list-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports